import React, { useCallback, useEffect, useState } from "react"
import {
    MdDoneAll,
    MdFilterAlt,
    MdHistory,
    MdInbox,
    MdLabelOutline,
    MdSwapVert,
} from "react-icons/md"
import { HiOutlineSwitchHorizontal } from "react-icons/hi"
import { toast } from "react-toastify"
import api from "../../services/api"
import BulkActionHistory from "./BulkActionHistory"

const actionIcons = {
    read: MdDoneAll,
    flags: MdLabelOutline,
    status: MdSwapVert,
    transfer: HiOutlineSwitchHorizontal,
}

const ManagementLogChat = () => {
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const getAll = useCallback(async ({ silent = false } = {}) => {
        try {
            if (!silent) setIsLoading(true)
            const response = await api.get("/chat/conversations/management")
            setData(response.data?.data || [])
        } catch (err) {
            if (!silent) toast.error(err?.response?.data?.message || "Não foi possível carregar o histórico.")
        } finally {
            if (!silent) setIsLoading(false)
        }
    }, [])

    useEffect(() => {
        getAll()
    }, [getAll])

    const handleCancel = async id => {
        try {
            setIsLoading(true)
            const response = await api.patch(`/chat/conversations/management/${id}/cancel`)
            const status = response?.data?.data?.status || "canceled"
            setData(previous => previous.map(item => item._id === id
                ? { ...item, status, can_cancel: false }
                : item
            ))
            toast.success(response?.data?.message)
            return true
        } catch (err) {
            toast.error(err?.response?.data?.message || "Não foi possível cancelar a execução.")
            return false
        } finally {
            setIsLoading(false)
        }
    }

    const getDetails = item => {
        const details = [
            { label: "Registros previstos", value: item.count || 0 },
            { label: "Processados / restantes", value: `${item.count_updated || 0} / ${item.remaining || 0}` },
            { label: "Falhas", value: item.count_failed || 0 },
            { label: "Origem da ação", value: item.source_label },
            { label: "Início", value: item.started_at || "Ainda não iniciado" },
            { label: "Conclusão", value: item.finished_at || "Em aberto" },
            { label: "Tomadas pelo worker", value: item.attempts || 0 },
            { label: "Última atualização", value: item.updated_at },
            { label: "Identificador da execução", value: item._id, executionId: true },
        ]
        if (item.filter_summary?.length) details.push({ label: "Filtros utilizados", items: item.filter_summary })
        else if (item.source_label === "Filtros") details.push({ label: "Filtros utilizados", value: "Sem filtros adicionais além das caixas selecionadas." })
        if (item.error_samples?.length) details.push({
            label: "Amostras de falha",
            items: item.error_samples.map(error => `${error.conversation_id}: ${error.message}`),
        })
        return details
    }

    return (
        <BulkActionHistory
            data={data}
            description="Acompanhe o que mudou, quem executou e o resultado de cada processamento."
            isLoading={isLoading}
            onRefresh={getAll}
            onCancel={handleCancel}
            cancelText="Se ela já tiver começado, será interrompida com segurança ao final do lote atual."
            progressLabel="Atendimentos processados"
            issueLabel="Com falha"
            getActionIcon={item => actionIcons[item.action] || MdHistory}
            getMetadata={item => [
                { icon: MdFilterAlt, value: item.source_label },
                { icon: MdInbox, value: item.inbox_names?.length ? item.inbox_names.join(", ") : "Caixa não identificada" },
            ]}
            getDetails={getDetails}
            getError={item => item.error || (item.count_failed > 0
                ? `${item.count_failed} atendimento${item.count_failed === 1 ? " apresentou" : "s apresentaram"} falha durante o processamento.`
                : null
            )}
        />
    )
}

export default ManagementLogChat
